import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';

import App from './js/App';
import Firebase from './js/Firebase/Firebase';
import { FirebaseContextProvider } from './js/Firebase/context';
import * as serviceWorker from './service-worker';

import { Provider as SpectrumProvider, defaultTheme  } from '@adobe/react-spectrum';
import { Provider as ReduxProvider } from 'react-redux';
import configureStore from './store/configure-store';

const store = configureStore();

// let firebase = new Firebase();

/*
messaging.onMessage((payload) => {
  console.log('Message received. ', payload);
  // ...
});
*/

ReactDOM.render(
  <React.StrictMode>
  <ReduxProvider store={store}>
  <SpectrumProvider theme={defaultTheme} colorScheme="light" >
  <FirebaseContextProvider value={new Firebase()}>
    <App />
    </FirebaseContextProvider>
    </SpectrumProvider>
    </ReduxProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

export {
  store
};

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
